// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Insta_wrapper__Chj4W","title":"Insta_title__d5uC_","tags":"Insta_tags__NbISq","photos":"Insta_photos__QRNWR","photo":"Insta_photo__5ObkP","big":"Insta_big___V_xC"};